// hooks/useUserData.js
import { useState, useEffect } from 'react';

export const useUserData = () => {
  const [userData, setUserData] = useState({
    id_pet: null,
    id_rol: null,
    sucursales: [],
    nombre_sucursal: '',
    id_usuario: '',
    nombre_veterinaria: '',
    nombre_usuario: '',
    es_delegado: false,
    es_titular: false,
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      
      console.log("📌 Payload del token:", payload); // ← Para debug

      setUserData({
        id_pet: payload.id_pet,
        id_rol: payload.id_rol,
        sucursales: payload.sucursales || [],
        nombre_sucursal: payload.nombre_sucursal || '',
        id_usuario: payload.id_usuario || '',
        nombre_veterinaria: payload.nombre_veterinaria || '',
        nombre_usuario: payload.nombre_usuario || '',
        es_delegado: payload.es_delegado || false,
        es_titular: payload.es_titular || false,
      });
    } catch (err) {
      console.error('Error al decodificar token:', err);
      localStorage.removeItem('token'); // Limpia token corrupto
    }
  }, []);

  return userData;
};